// Application
import { useAppContext } from 'context'
import { HelpModalData, HelpModalInstances } from 'constants/helpmodal'
import { AccountExistsModalData, AccountExistsModalInstances } from 'constants/accountExistsModal'
import { LinkProps } from 'typings/components'

export const useAppHook = () => {
    const { state, operations } = useAppContext()
    const { setToast, setHelpModal, setAccountExistsModal } = operations

    const openToast = (mes: string) => {
        setToast({ show: true, message: mes })
        setTimeout(() => {
            setToast({ show: false, message: '' })
        }, 4000)
    }

    const closeToast = () => {
        setToast({ show: false, message: '', link: undefined })
    }

    const openToastLink = (message: string, link: LinkProps) => {
        const newState = {
            show: true,
            message: message,
            link: {
                to: link.to,
                text: link.text,
            },
        }
        setToast(newState)
    }

    const openHelpModal = (modal: HelpModalInstances, onComplete?: Function) => {
        // eslint-disable-next-line prefer-destructuring
        const modalData = HelpModalData[modal]
        setHelpModal({ ...modalData, showModal: true })
        if (onComplete) {
            onComplete()
        }
    }

    const closeHelpModal = () => {
        setHelpModal(undefined)
    }

    const openAccountExistsModal = (modal: AccountExistsModalInstances, onComplete?: Function) => {
        // eslint-disable-next-line prefer-destructuring
        const modalData = AccountExistsModalData[modal]
        setAccountExistsModal({ ...modalData, showModal: true })

        if (onComplete) {
            onComplete()
        }
    }

    const closeAccountExistsModal = () => {
        setAccountExistsModal(undefined)
    }

    return {
        ...state,
        openToast,
        closeToast,
        openHelpModal,
        openToastLink,
        closeHelpModal,
        openAccountExistsModal,
        closeAccountExistsModal,
    }
}
